export default "__VITE_ASSET__BFRx2WEl__"